import { render, staticRenderFns } from "./banRoleChat.vue?vue&type=template&id=6db921b0&"
import script from "./banRoleChat.vue?vue&type=script&lang=js&"
export * from "./banRoleChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db921b0')) {
      api.createRecord('6db921b0', component.options)
    } else {
      api.reload('6db921b0', component.options)
    }
    module.hot.accept("./banRoleChat.vue?vue&type=template&id=6db921b0&", function () {
      api.rerender('6db921b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/components/banRoleChat.vue"
export default component.exports